import { useCallback, useContext } from 'react';

import { RootContext } from '../../root/RootContext';

export const useSidebar = () => {
  const { state, dispatch } = useContext(RootContext);

  const show = useCallback(
    (content) => {
      dispatch({ type: 'sidebar/SET_SIDEBAR_STATE', isOpen: true, content });
    },
    [dispatch]
  );
  const hide = useCallback(
    () => dispatch({ type: 'sidebar/SET_SIDEBAR_STATE', isOpen: false }),
    [dispatch]
  );

  return { show, hide, sidebar: state.sidebar };
};

export const useNavbar = () => {
  const { state, dispatch } = useContext(RootContext);

  const show = useCallback(
    (content) => {
      dispatch({ type: 'navbar/SET_NAVBAR_STATE', isOpen: true, content });
    },
    [dispatch]
  );
  const hide = useCallback(
    () => dispatch({ type: 'navbar/SET_NAVBAR_STATE', isOpen: false }),
    [dispatch]
  );

  return { show, hide, navbar: state.navbar };
};
